import { RollUpdater } from "./RollUpdater";
export async function loadRollUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("roll", () => new RollUpdater(), refresh);
}
